import { buttonBlockDefinition } from "./button";
import { buttonRowBlockDefinition } from "./button-row";
import { dividerBlockDefinition } from "./divider";
import { eyebrowBlockDefinition } from "./eyebrow";
import { imageBlockDefinition } from "./image";
import { socialBlockDefinition } from "./social";
import { spacerBlockDefinition } from "./spacer";
import { textBlockDefinition } from "./text";
import type { BlockDefinition } from "./types";
import type { BlockType } from "../types";

const BLOCK_DEFINITION_ENTRIES: Record<BlockType, BlockDefinition> = {
  text: textBlockDefinition,
  image: imageBlockDefinition,
  button: buttonBlockDefinition,
  divider: dividerBlockDefinition,
  spacer: spacerBlockDefinition,
  social: socialBlockDefinition,
  eyebrow: eyebrowBlockDefinition,
  buttonRow: buttonRowBlockDefinition,
};

export const BLOCK_TYPE_ORDER: BlockType[] = [
  'text',
  'image',
  'button',
  'divider',
  'spacer',
  'social',
  'eyebrow',
  'buttonRow',
];

export const BLOCK_DEFINITION_PALETTE = BLOCK_TYPE_ORDER.map(
  type => BLOCK_DEFINITION_ENTRIES[type],
);

export function getBlockDefinition(type: BlockType): BlockDefinition {
  return BLOCK_DEFINITION_ENTRIES[type];
}
